import { LitElement, html } from 'lit'

class FeatureCard extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    static properties = {
        icon: { type: String },
        title: { type: String },
        description: { type: String }
    }

    constructor() {
        super()
        this.icon = ''
        this.title = ''
        this.description = ''
    }

    render() {
        return html`
            <div class="card p-8 text-center group cursor-pointer h-full">
                <!-- Icon -->
                <div class="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-primary-100 to-primary-50 dark:from-primary-900/30 dark:to-primary-800/20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <sl-icon
                        library="${this.icon.split(' ')[0]}"
                        name="${this.icon.split(' ')[1]}"
                        class="text-3xl text-primary-600 dark:text-primary-400">
                    </sl-icon>
                </div>

                <!-- Title -->
                <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-4 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors duration-300">
                    ${this.title}
                </h3>

                <!-- Description -->
                <p class="text-gray-600 dark:text-gray-400 leading-relaxed">
                    ${this.description}
                </p>

                <!-- Hover effect indicator -->
                <div class="mt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <sl-icon
                        library="fa-solid"
                        name="fa-arrow-right"
                        class="text-primary-600 dark:text-primary-400">
                    </sl-icon>
                </div>
            </div>
        `
    }
}

customElements.define('feature-card', FeatureCard)